export namespace Coordinates {

  export interface IConfigs {
    index: number;
    viewType: ViewType;
    centerCoords: {
      left: number;
      top: number;
    };
    canvas: any;
    countElements?: number;
  }

  export interface ICoordinates {
    x: number;
    y: number;
  }

  export enum ViewType {
    cloud,
    circle,
    cloudStatic,
  }
}
